import React, { useState } from "react";
import { List, ListItem, ListItemText, Collapse, Badge, Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import Icon from '@material-ui/core/Icon';
import { useHistory } from "react-router-dom";
import { genfunction } from "helpers";

const useStyles = makeStyles(theme => ({

    menuItem: {
        color: theme.palette.primary.contrastText
    },
    menuItemText: {
        color: theme.palette.primary.contrastText,
        fontSize: 14,
        marginLeft: 10,
        marginTop: 5,
        cursor: 'pointer',
    }
}
));

export default function RecursiveVerticalMenu({ item, setIsMenuDrawerOpen, level = 0 }) {

    const classes = useStyles();
    let history = useHistory();

    const [open, setOpen] = useState(false);

    const handlePageClick = (pageURL) => {

        if (genfunction.IsExternalUrl(pageURL))
            window.location.href = pageURL;
        else {
            history.push(pageURL);
            setIsMenuDrawerOpen(false);
        }

    }

    const handleToggle = (e) => {
        e.stopPropagation(); // prevent parent clicks
        setOpen(!open);
    };

    const onClickMenu = (e) => {

        if (item?.Type === "page")
            handlePageClick(item?.PageURL)
        else if (genfunction.IsArrayNotEmptyNullUndefined(item?.MenuAndPages))
            handleToggle(e)

    }

    return (
        <>
            <ListItem
                style={{ paddingLeft: level > 0 ? level * 50 : '' }}
                button
                onClick={onClickMenu}
            >
                <Badge variant="standard" style={{ flex: 1 }}>
                    {item?.Icon ? <Icon className={classes.menuItem}>{item?.Icon}</Icon> : <Box sx={{ width: 24 }} />}
                    <ListItemText disableTypography className={classes.menuItemText} primary={genfunction.replaceEscapeCharacters(item?.Title)} />
                </Badge>

                {genfunction.IsArrayNotEmptyNullUndefined(item?.MenuAndPages) && (
                    open ? <Icon className={classes.menuItem}>expand_less</Icon> : <Icon className={classes.menuItem}>expand_more</Icon>)
                }
            </ListItem>

            <Collapse in={open} timeout="auto" unmountOnExit>
                <List disablePadding>

                    {genfunction.IsArrayNotEmptyNullUndefined(item?.MenuAndPages) && item.MenuAndPages.map((child, i) => (
                        <RecursiveVerticalMenu
                            key={child?.Identifier}
                            item={child}
                            setIsMenuDrawerOpen={setIsMenuDrawerOpen}
                            level={level + 1}
                        />
                    ))}
                </List>
            </Collapse>
        </>
    )
}

